import { render, staticRenderFns } from "./ChatExport.vue?vue&type=template&id=38a783e7"
import script from "./ChatExport.vue?vue&type=script&lang=js"
export * from "./ChatExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports